export default "__VITE_ASSET__BVL54D9w__"